import { Navigate, Route, Routes } from "react-router";
import { ContactClippingList } from "../clippings/details/ContactClippingList";
import { ContactEventList } from "../contacts/ContactEventList";
import { DefaultContentLayout, ViewPageContentLayout } from "../shared/Layout";
import { ArchivedContactViewPage } from "./view/ArchivedContactViewPage";

export const ArchivedContactDetails = () => {
	return (
		<>
			<Routes>
				<Route index element={<Navigate to="details" replace />} />
				<Route
					path="details"
					element={
						<ViewPageContentLayout>
							<ArchivedContactViewPage />
						</ViewPageContentLayout>
					}
				/>
				<Route
					path="clippings"
					element={
						<DefaultContentLayout>
							<ContactClippingList readonly />
						</DefaultContentLayout>
					}
				/>
				<Route
					path="events"
					element={
						<DefaultContentLayout>
							<ContactEventList />
						</DefaultContentLayout>
					}
				/>
			</Routes>
		</>
	);
};
